<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="12">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"></i> Ajouter un Virement </strong>
          </div>


          <b-row class="mt-3">
            <b-col sm="4">
              <b-form-group
                label="Montant"
                label-for="montant"
              >
                <b-form-input id="montant" type="text" :class="{hasError: errors.montant !== ''}" v-model="montant"></b-form-input>
                <span class="field-error">{{ errors.montant }}</span>
              </b-form-group>

            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Date execution"
                label-for="dateExecution"
              >
                <b-form-input id="dateExecution" type="date" :class="{hasError: errors.dateExecution !== ''}" v-model="dateExecution"></b-form-input>
                <span class="field-error">{{ errors.dateExecution }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Référence 1 (nom client)"
                label-for="nomClient"
              >
                <b-form-input id="nomClient" type="text" :class="{hasError: errors.nomClient !== ''}" v-model="nomClient"></b-form-input>
                <span class="field-error">{{ errors.nomClient }}</span>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row class="mt-3">

            <b-col sm="4">
              <b-form-group
                label="Référence 2 (endtoendid)"
                label-for="EndToEndId"
              >
                <b-form-input id="EndToEndId" type="text" :class="{hasError: errors.EndToEndId !== ''}" v-model="EndToEndId"></b-form-input>
                <span class="field-error">{{ errors.EndToEndId }}</span>
              </b-form-group>

            </b-col>

            <b-col sm="4">
              <b-form-group
                label="Référence 3 (ustrd)"
                label-for="ustrd"
              >
                <b-form-input id="ustrd" type="text" :class="{hasError: errors.ustrd !== ''}" v-model="ustrd"></b-form-input>
                <span class="field-error">{{ errors.ustrd }}</span>
              </b-form-group>

            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Référence 4 (ultmt)"
                label-for="ultmt"
              >
                <b-form-input id="ultmt" type="text" :class="{hasError: errors.ultmt !== ''}" v-model="ultmt"></b-form-input>
                <span class="field-error">{{ errors.ultmt }}</span>
              </b-form-group>

            </b-col>

          </b-row>
          <b-row class="mt-3">
            <b-col sm="4">

            <b-form-group
              label="SIREN"
              label-for="siren"
            >
              <b-form-input id="siren" type="text" :class="{hasError: errors.siren !== ''}" v-model="siren"></b-form-input>
              <span class="field-error">{{ errors.siren }}</span>
            </b-form-group>

            </b-col>
            <b-col sm="4">
              <b-form-group
                label="IBAN"
                label-for="iban"
              >
                <b-form-input id="iban" type="text" :class="{hasError: errors.iban !== ''}" v-model="iban"></b-form-input>
                <span class="field-error">{{ errors.iban }}</span>
              </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Initiales IBAN"
                label-for="initialesIban"
              >
                <b-form-input id="initialesIban" type="text" :class="{hasError: errors.initialesIban !== ''}" v-model="initialesIban"></b-form-input>
                <span class="field-error">{{ errors.initialesIban }}</span>
              </b-form-group>

            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col sm="4">
               <b-form-group label="Gestionnaire" label-for="gestionnaire">
                    <b-form-select
                      id="gestionnaire"
                      :plain="true"
                      :options="gestionnairesOptions"
                      v-model="gestionnaire"
                    ></b-form-select>
                        <span class="field-error">{{ errors.gestionnaire }}</span>
                  </b-form-group>


            </b-col>
            <b-col sm="4">
               <b-form-group label="Statut" label-for="statut">
                    <b-form-select
                      id="statut"
                      :plain="true"
                      :options="statutsOptions"
                      v-model="statut"
                    ></b-form-select>
                        <span class="field-error">{{ errors.statut }}</span>
                  </b-form-group>
            </b-col>
            <b-col sm="4">
              <b-form-group
                label="Avis Appel"
                label-for="avisAppel"
              >
                <b-form-input id="avisAppel" type="text" :class="{hasError: errors.avisAppel !== ''}" v-model="avisAppel"></b-form-input>
                <span class="field-error">{{ errors.avisAppel }}</span>
              </b-form-group>


            </b-col>
          </b-row>
          <b-row class="mt-3">
            <b-col sm="4">

            <b-form-group
              label="Montant non ventilé"
              label-for="montantNonVentile"
            >
              <b-form-input id="montantNonVentile" type="text" :class="{hasError: errors.montantNonVentile !== ''}" v-model="montantNonVentile"></b-form-input>
              <span class="field-error">{{ errors.montantNonVentile }}</span>
            </b-form-group>

            </b-col>
            <b-col sm="4">

            <b-form-group
              label="Raison blocage"
              label-for="raisonBlocage"
            >
              <b-form-input id="raisonBlocage" type="text" :class="{hasError: errors.raisonBlocage !== ''}" v-model="raisonBlocage"></b-form-input>
              <span class="field-error">{{ errors.raisonBlocage }}</span>
            </b-form-group>

            </b-col>
            <b-col sm="4">
            <b-form-group
              label="Numéro TP"
              label-for="numeroTP"
            >
              <b-form-input id="numeroTP" type="text" :class="{hasError: errors.numeroTP !== ''}" v-model="numeroTP"></b-form-input>
              <span class="field-error">{{ errors.numeroTP }}</span>
            </b-form-group>

            </b-col>
          </b-row>
            <div slot="footer">
              <b-button type="button" @click="returnBack" size="md" variant="secondary">
                <i class="fa fa-arrow-left"></i> Liste des reglements
              </b-button>
              <b-button type="button" @click="create" size="md" class="pull-right" variant="primary">
                <i class="fa fa-save"></i> Enregistrer
              </b-button>
            </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../../utils/auth'
import {espaceRPARules, hasRule} from '../../../utils/rulesHelper'
import IbanValidator from 'iban/iban.js';

export default {
  data() {
    return {
      rules: espaceRPARules,
      iban : '',
      initialesIban: '',
      siren: '',
      montant: '',
      dateExecution: '',
      EndToEndId: '',
      ustrd: '',
      ultmt: '',
      nomClient: '',
      gestionnaire: '',
      gestionnairesOptions: [],
      statut: '',
      statutsOptions: [
                        { value:'Traité',
                          text :'Encaissé sur NSI (Traité)'
                        },
                        { value :'Encaissé',
                          text:'Encaissé sur NSI (Encaissé)'
                        },
                        { value :'Encaissé avec non-ventilé',
                          text:'Encaissé sur NSI (Encaissé avec non-ventilé)'
                        },
                        { value :'Neutralisé',
                          text:'Neutralisé'
                        },
                        { value :'En cours de traitement',
                          text:'Non encaissé sur NSI (En cours de traitement)'
                        },
                        { value :'En attente de traitement',
                          text:'Non ecaissé sur NSI (En attente de traitement)'
                        },
                        { value :'En attente d\'envoi à la banque',
                          text:'Non ecaissé sur NSI (En attente d\'envoi à la banque)'
                        }
                      ],
      avisAppel: '',
      montantNonVentile: '',
      raisonBlocage: '',
      numeroTP: '',
      DatePickerFormat: 'dd/MM/yyyy',
      errors: {
        iban: '',
        initialesIban: '',
        siren: '',
        montant: '',
        dateExecution: '',
        EndToEndId: '',
        ustrd: '',
        ultmt: '',
        nomClient: '',
        gestionnaire: '',
        statut: '',
        avisAppel: '',
        montantNonVentile: '',
        raisonBlocage: '',
        numeroTP: '',
      }
    }
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
    this.getGestionnaires();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    getGestionnaires(){
      this.$axios
        .get("/espaceRPA/reglements/gestionnaires/list")
        .then(response => {
          let gestionnaires = response.data.gestionnaires;
          for (let key in gestionnaires){
            if (this.gestionnairesOptions.indexOf(gestionnaires[key].nom) < 0){
              this.gestionnairesOptions.push({
                text: gestionnaires[key].nom,
                value: gestionnaires[key].nom
              });
            }
          }
          this.gestionnairesOptions.sort();
          console.log(this.gestionnairesOptions);
        })
        .catch(function(error) {});

    },
   create() {
      if (this.validateData()) {
        this.$store.commit('IS_LOADING', true)
        let self = this;
        let errorText = '';
        let dataPost = {};

        dataPost.ibanclient = this.iban;
        dataPost.siren = this.siren;
        dataPost.amt = this.montant.replace(/ /g, "").replace(/\./g, ",");
        dataPost.timestamp = this.dateExecution;
        dataPost.endtoendid = this.EndToEndId;
        dataPost.nomclient = this.nomClient;
        dataPost.ustrd = this.ustrd;
        dataPost.ultmt = this.ultmt;
        dataPost.initialesiban = this.initialesIban;
        dataPost.gestionnaire = this.gestionnaire;
        dataPost.statut = this.statut;
        dataPost.avisappel = this.avisAppel;
        dataPost.montantnonventile = this.montantNonVentile;
        dataPost.raisonblocage = this.raisonBlocage;
        dataPost.numerotp = this.numeroTP;

        this.$axios
          .post("/espaceRPA/reglements/virement/create", dataPost)
          .then(response => {
              this.$store.commit('IS_LOADING', false)
              this.$swal({ position: 'top', type: 'success', title:'Création avec succès', text:'Le virement a bien été créé',showConfirmButton: false, timer: 5000})
              this.$router.push({ path: '/suivi-cotisations/reglements/list' })
              this.returnBack()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            //if (error.response){
              errorText = 'Un problème est survenu, merci de contacter le support';
            //}
            self.$swal({ position: 'top', type: 'error', title:'Attention !!', text:errorText,showConfirmButton: false, timer: 5000})
          });
      }
    },
    returnBack() {
      this.$router.push({ path: '/suivi-cotisations/reglements/list' })
    },
    validateData () {
      this.clearErrors();
      this.siren = this.siren.replace(/\s/g, '');
      let regNumeric = this.$store.getters.getRegNumeric
      let valid = true;

      if (this.iban === "") {
        this.errors.iban = "L'IBAN est obligatoire";
        valid= false;
      } else if (!IbanValidator.isValid(this.iban)) {
         valid = false
         this.errors.iban  = "L'IBAN est invalide"
      }

      if (this.siren === "") {
        this.errors.siren = "Le SIREN est obligatoire";
        valid= false;
      } else if (this.siren.length != 9) {
         valid = false
         console.log(this.siren.length);
         this.errors.siren  = 'Veuillez entrer un SIREN de 9 chiffres'
      }else{
        if(this.checkSiren() == false){
          valid = false;
          this.errors.siren  = 'Le SIREN est invalide.'
        }
      }

      let montant = this.montant.replace(/ /g, "").replace(/,/g, ".")
      if (montant === '') {
        this.errors.montant = "Le montant est obligatoire";
      }else if(isNaN(montant)) {
        this.errors.montant = 'Le montant doit contenir que des chiffres'
        valid = false
      } else if (montant.length > 15) {
        this.errors.montant = 'Le montant saisi est invalide'
        valid = false
      }

      let montantnonventile = this.montantNonVentile.replace(/ /g, "")
      if (montantnonventile !== '') {
         if(isNaN(montantnonventile)) {
            this.errors.montantnonventile = 'Le montant non ventilé doit contenir que des chiffres'
            valid = false
          } else if (montantnonventile.length > 15) {
            this.errors.montantnonventile = 'Le montant non ventilé saisi est invalide'
            valid = false  
          }
      }
      
      if (this.dateExecution === "") {
        this.errors.dateExecution = "La date d'execution est obligatoire";
        valid= false;
      }

      let nomClient = this.nomClient.replace(/ /g, "")
      if (nomClient === "") {
        this.errors.nomClient = "Le nom du client est obligatoire";
        valid= false;
      }

     let EndToEndId = this.EndToEndId.replace(/ /g, "")
      if (EndToEndId === "") {
        this.errors.EndToEndId = "La référence 2 est obligatoire";
        valid= false;
      }

     let ustrd = this.ustrd.replace(/ /g, "")
      if (ustrd === "") {
        this.errors.ustrd = "La référence 3 est obligatoire";
        valid= false;
      }

     let ultmt = this.ultmt.replace(/ /g, "")
      if (ultmt === "") {
        this.errors.ultmt = "La référence 4 est obligatoire";
        valid= false;
      }

     let initialesiban = this.initialesIban.replace(/ /g, "")
      if (initialesiban === "") {
        this.errors.initialesIban = "Les initiales IBAN sont obligatoires";
        valid= false;
      }

      let gestionnaire = this.gestionnaire.replace(/ /g, "")
      if (gestionnaire === "") {
        this.errors.gestionnaire = "Le gestionnaire est obligatoire";
        valid= false;
      }

      let statut = this.statut.replace(/ /g, "")
      if (this.statut === "") {
        this.errors.statut = "Le statut est obligatoire";
        valid= false;
      }
      
      return valid;
    },
    clearErrors() {
      this.errors.iban = "";
      this.errors.siren = "";
      this.errors.initialesIban = "";
      this.errors.montant = "";
      this.errors.dateExecution = "";
      this.errors.EndToEndId = "";
      this.errors.ustrd = "";
      this.errors.ultmt = "";
      this.errors.nomClient = "";
      this.errors.gestionnaire = "";
      this.errors.statut = "";
      this.errors.avisAppel = "";
      this.errors.montantNonVentile = "";
      this.errors.raisonBlocage = "";
      this.errors.numeroTP = "";

    },
    checkSiren(){
      let siren = this.siren;
      
      if ( (siren.length != 9) || (isNaN(siren)) )
        return false;
      else {
        var somme = 0;
        var tmp;
        for (var cpt = 0; cpt<siren.length; cpt++) {
          if ((cpt % 2) == 1) { // Les positions paires : 2ème, 4ème, 6ème et 8ème chiffre
            tmp = siren.charAt(cpt) * 2; // On le multiplie par 2
            if (tmp > 9) 
              tmp -= 9; // Si le résultat est supérieur à 9, on lui soustrait 9
          }
          else
            tmp = siren.charAt(cpt);
          somme += parseInt(tmp);
        }
        if ((somme % 10) == 0)
          return true;
        else
          return  false;
      }
      return false;
    }
  }
}
</script>
